import { render, staticRenderFns } from "./dog-purchase-transaction-failed.vue?vue&type=template&id=766d29b2&scoped=true&lang=pug"
import script from "./dog-purchase-transaction-failed.js?vue&type=script&lang=js&external"
export * from "./dog-purchase-transaction-failed.js?vue&type=script&lang=js&external"
import style0 from "./dog-purchase-transaction-failed.vue?vue&type=style&index=0&id=766d29b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766d29b2",
  null
  
)

export default component.exports